<template>
  <div class="flex flex-col h-full">
    <div class="flex justify-between px-4 mt-2 items-center mb-1">
      <SelectFriendMate
        :active-mate-id="props.mateId"
        :other-mate-id="otherMateId"
        @update:other-mate-id="onConfirmOtherOc"
      />
      <TimeSort :sort="activeSort" @update:sort="onSorterChange" />
    </div>
    <ThreadList
      class="flex-1"
      ref="threadList"
      :on-pull-load="() => reload()"
      :on-scroll-load="() => loadNextPage()"
    >
      <div class="flex flex-col gap-2 px-2 py-2 overflow-auto h-full">
        <MateMailItem
          v-for="mail in missionStore.mateMailList"
          :key="mail.id"
          :mail="mail"
          is-select
          :include="props.include"
          @select="emit('select', mail)"
        />
      </div>
    </ThreadList>
  </div>
</template>

<script setup lang="ts">
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { useMission } from "@/stores/mission";
import { MateMail } from "@/types/entity";
import { onActivated, onMounted, ref } from "vue";

const props = defineProps<{
  mateId: number;
  include: number[];
  recipientId?: number;
}>();

const emit = defineEmits<{
  (e: "select", mail: MateMail): void;
}>();

const otherMateId = ref<number | undefined>(undefined);

const onConfirmOtherOc = (value?: number) => {
  otherMateId.value = value ?? undefined;
  reload();
};

const missionStore = useMission();
const threadList = ref<ThreadListInstance>();

const reload = async () => {
  missionStore.mateMailList = [];
  threadList.value?.resetScrollLoadingState();
};

const activeSort = ref<"desc" | "asc">("desc");
const onSorterChange = (sort: "desc" | "asc") => {
  activeSort.value = sort;
  reload();
};
const loadNextPage = async () => {
  const { length } = missionStore.mateMailList;
  const page = length / 5 + 1;
  if (length !== 0 && length % 5 !== 0) return false;
  const list = await missionStore.getMateMailList(
    page,
    props.mateId,
    otherMateId.value,
    activeSort.value
  );
  return list.length === 5;
};

onMounted(() => {
  reload();
  otherMateId.value = props.recipientId;
});

onActivated(() => {
  reload();
  otherMateId.value = props.recipientId;
});
</script>
